import Axios from "axios";

export interface Waffles {
  flags: { [key: string]: boolean };
  switches: {
    stakeholder: boolean;
    custom_deposit_method: boolean;
    "auction-and-lot-ids": boolean;
    "manage-users-page": boolean;
    "wings-integration": boolean;
    remove_deposit: boolean;
    deposit_refund_reason: boolean;
  };
}

export async function getWaffles() {
  const response = await Axios.get<Waffles>("/api/waffle/");
  return response.data;
}
